export default "__VITE_ASSET__BmbjtszZ__";